import { render, staticRenderFns } from "./BannerVencimiento.vue?vue&type=template&id=f21eb1a8"
import script from "./BannerVencimiento.vue?vue&type=script&lang=js"
export * from "./BannerVencimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports